import { FC } from 'react';

interface IconProps {
  size?: number;
  className?: string;
}

export const BizzIcon: FC<IconProps> = ({ size = 16, className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M5.12779 6.54567L1.14141 10.5321C0.733233 10.9402 0.687692 11.5565 1.03969 11.9085L7.41531 18.2841C7.76731 18.6361 8.38355 18.5905 8.79172 18.1824L12.7781 14.196C13.1863 13.7878 13.2318 13.1716 12.8798 12.8196L6.5042 6.44395C6.1522 6.09196 5.53596 6.1375 5.12779 6.54567Z"
      stroke="currentcolor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M18.111 8.99612C18.1386 5.045 14.9582 1.86458 11.0071 1.89226M15.25 9.01473C15.2654 6.64446 13.3568 4.73582 10.9865 4.75124M12.3891 9.03335C12.3942 8.24194 11.7593 7.60703 10.9679 7.61218"
      stroke="currentcolor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
